import { cn } from "@/lib/utils";

interface LegalTextProps {
  className?: string;
  title: string;
  description?: string;
  footerNote?: string;
}
export default function LegalText({ title, description, footerNote, className }: LegalTextProps) {
  return (
    <section className={cn("w-full flex flex-col gap-4", className)}>
      <h3 className="text-fb-primary text-3xl font-bold">{title}</h3>
      {description && (
        <p className="text-xl text-slate-900">{description}</p>
      )}
      {footerNote && (
        <p className="text-base text-slate-900/700">{footerNote}</p>
      )}
    </section>
  )
}